var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkTo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.93457C12 1.31551 12.4477 0.81366 13 0.81366H19C19.5523 0.81366 20 1.31551 20 1.93457V8.66006C20 9.27913 19.5523 9.78098 19 9.78098C18.4477 9.78098 18 9.27913 18 8.66006V3.05549H13C12.4477 3.05549 12 2.55364 12 1.93457Z",
    fill: "#000A13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7071 2.26288C19.0976 2.70063 19.0976 3.41035 18.7071 3.8481L8.70711 15.0572C8.31658 15.495 7.68342 15.495 7.29289 15.0572C6.90237 14.6195 6.90237 13.9098 7.29289 13.472L17.2929 2.26288C17.6834 1.82514 18.3166 1.82514 18.7071 2.26288Z",
    fill: "#000A13"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6.41823C2.44772 6.41823 2 6.92009 2 7.53915V19.8692C2 20.4883 2.44772 20.9901 3 20.9901H14C14.5523 20.9901 15 20.4883 15 19.8692V13.1437C15 12.5247 15.4477 12.0228 16 12.0228C16.5523 12.0228 17 12.5247 17 13.1437V19.8692C17 21.7264 15.6569 23.232 14 23.232H3C1.34315 23.232 0 21.7264 0 19.8692V7.53915C0 5.68196 1.34315 4.1764 3 4.1764H9C9.55229 4.1764 10 4.67826 10 5.29732C10 5.91638 9.55229 6.41823 9 6.41823H3Z",
    fill: "#000A13"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkTo);
export default __webpack_public_path__ + "static/media/LinkTo.b7c1e3197e3b22dc77c2df4cb894cc09.svg";
export { ForwardRef as ReactComponent };